// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"qG96Yzk","errorMessage":"h80OUA7"};